import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "./Toast";
import { useToast } from "@/hooks/useToast";

/**
 *
 */
export function Toaster() {
  const { toasts } = useToast();

  return (
    <ToastProvider>
      {toasts.map(function ({
        id,
        title,
        description,
        custom,
        action,
        // Destructured purely to keep it out of `...props` below: it is
        // internal arbitration metadata (see TOAST_PRIORITY), and spreading it
        // onto a custom component or a Radix Toast primitive would land it on
        // the DOM as an unrecognized attribute.
        ownerPriority,
        ...props
      }) {
        // If it's a custom toast, render the custom component
        if (custom) {
          const CustomComponent = custom.component;
          return (
            <CustomComponent
              key={id}
              {...custom.props}
              {...props}
              onDismiss={() => props.onOpenChange?.(false)}
            />
          );
        }

        return (
          <Toast key={id} {...props}>
            <div className="grid gap-1">
              {title && <ToastTitle>{title}</ToastTitle>}
              {description && (
                <ToastDescription>{description}</ToastDescription>
              )}
            </div>
            {action}
            <ToastClose />
          </Toast>
        );
      })}
      <ToastViewport />
    </ToastProvider>
  );
}
